import { render } from "./PersonalNotificationModal.vue?vue&type=template&id=ca480b26&scoped=true"
import script from "./PersonalNotificationModal.vue?vue&type=script&lang=js"
export * from "./PersonalNotificationModal.vue?vue&type=script&lang=js"

import "./PersonalNotificationModal.vue?vue&type=style&index=0&id=ca480b26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca480b26"]])

export default __exports__